import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BillingManagementService } from '../../../service/billing-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues5, KeyValues3, LocalService, Status, ActiveInactiveFor, KeyValueSet, SeatType, FocusInputType, TriggeredEvent } from '../../../service/local.service';

@Component({
  selector: 'app-seat-reservation-config',
  templateUrl: './seat-reservation-config.component.html',
  styleUrls: ['./seat-reservation-config.component.scss']
})
export class SeatReservationConfigComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["reservation", "table"]; maxBodyHeight = 0; isRedAlert = true; message = '';
  businessId = ''; groupTitles: KeyValues3[]; wrapper: KeyValues5; seats: KeyValues3[]; isInstant = false;
  seatsStatusAndTitle: KeyValueSet[] = []; seatType: SeatType = SeatType.Line;
  htmlId: string = ''; elementIds: any;

  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private cdr: ChangeDetectorRef, private billingManagementService: BillingManagementService, private activeModal: NgbActiveModal) { 
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      seat_cnt: 'seat_cnt_' + this.htmlId,
      seat_code: 'seat_code_' + this.htmlId,
      seat_save: 'seat_save+' + this.htmlId
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  onLoad() {
    this.billingManagementService.getSeatTitles(this.businessId).subscribe(result => {
      this.groupTitles = result;
      if (this.groupTitles.length > 0) {
        this.onAction(1, this.groupTitles[0].key);
      } else {
        this.onReset();
      }
    });
  }

  onLoadSeats() {
    this.billingManagementService.getSeatTitles(this.businessId, this.wrapper.key).subscribe(result => {
      this.seats = result;
      this.onSetSeatArrangement();
    });
  }

  onSetSeatArrangement() {
    this.seatType = parseInt(this.wrapper.v5);
    this.seatsStatusAndTitle = [];
    this.seats.filter(x => x.v2 == '0').forEach(x => {
      this.seatsStatusAndTitle.push({ isSelected: x.isSelected, value: x.v3 } as KeyValueSet);
    });
  }

  onReset() {
    this.wrapper = { isSelected: true, key: '', v1: '', v2: '', v3: this.businessId, v4: null, v5: '1', v6: '1' } as KeyValues5;
    this.localService.onFocusNextInput(this.elementIds.seat_code, FocusInputType.TextBox);
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onPopupSave() {
    if (this.doCheck()) {
      this.isRedAlert = false;
      this.billingManagementService.saveSeat(this.wrapper).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
        if (result.status == Status.Success) {
          if (this.isInstant) {
            this.activeModal.close({ event: TriggeredEvent.Ok, data: result.id });
          } else {
            this.onAction(5, result.id);
          }
        }
      });
    }
  }

  doCheck(): boolean {
    this.isRedAlert = true;
    this.message = '';
    if (!this.wrapper.v4) {
      this.message = this.localService.languageContent.reservation.seat_count_need;
      this.localService.onFocusNextInput(this.elementIds.seat_cnt, FocusInputType.TextBox);
    } else if (this.wrapper.key && this.seats && this.seats.filter(x => x.v2 == '0').length > this.wrapper.v4) {
      this.message = this.localService.languageContent.reservation.seat_cnt_invalid;
      this.localService.onFocusNextInput(this.elementIds.seat_cnt, FocusInputType.TextBox, true);
    } else if ((this.wrapper.key && this.groupTitles && this.groupTitles.filter(x => x.key != this.wrapper.key && x.v1.toLowerCase().trim() == this.wrapper.v1.toLowerCase().trim()).length > 0)
      || (!this.wrapper.key && this.groupTitles && this.groupTitles.filter(x => x.v1.toLowerCase().trim() == this.wrapper.v1.toLowerCase().trim()).length > 0)) {
        this.message = this.localService.languageContent.reservation.duplicate_code;
        this.localService.onFocusNextInput(this.elementIds.seat_code, FocusInputType.TextBox, true);
    }
    return this.message == '';
  }

  onAction(index: number, key = '') {
    this.message = '';
    switch (index) {
      case 1: {
        if (key == '')
          key = this.wrapper.key;
        let item = this.groupTitles.find(x => x.key == key);
        this.wrapper = { isSelected: item.isSelected, key: item.key, v1: item.v1, v2: '', v3: this.businessId, v4: parseInt(item.v2), v5: item.v3 } as KeyValues5;
        this.onLoadSeats();
        this.localService.onFocusNextInput(this.elementIds.seat_code, FocusInputType.TextBox);
      } break;
      case 2:
      case 3: {
        this.billingManagementService.activeInactiveStatus(key, index == 2 ? ActiveInactiveFor.Seat : ActiveInactiveFor.SeatDelete).subscribe(result => {
          if (result == Status.Success) {
            let item = this.seats.find(x => x.key == key);
            if (index == 2)
              item.isSelected = !item.isSelected;
            else {
              item.v2 = item.v2 == "1" ? "0" : "1";
              this.wrapper.v4 = this.seats.filter(x => x.v2 == '0').length;
            }
            this.onSetSeatArrangement();
          }
        });
      } break;
      case 4: {
        let item = this.seats.find(x => x.key == key);
        if (item.v1 != item.v3) {
          let value = item.v1;
          this.billingManagementService.updateSeatTitle(key, value).subscribe(result => {
            this.localService.showInformationByStatus(result);
            if (result == Status.Success) {
              item.v3 = value;
              this.onSetSeatArrangement();
            } else {
              item.v1 = item.v3;
            }
          });
        }
      } break;
      case 5: {
        this.billingManagementService.getSeatTitles(this.businessId).subscribe(result => {
          this.groupTitles = result;
          if (this.groupTitles.length > 0) {
            this.onAction(1, key);
          } else {
            this.onReset();
          }
        });
      } break;
      case 6: {
        this.localService.onFocusNextInput(this.elementIds.seat_save, FocusInputType.Button);
      } break;
      case 7: {
        this.localService.onFocusNextInput(this.elementIds.seat_cnt, FocusInputType.TextBox);
      } break;
    }
  }
}
